import { Component, inject } from '@angular/core';
import { Drawer } from 'primeng/drawer';
import { FormsModule } from '@angular/forms';
import { FileUploaderService } from '../../../services/file-uploader';
import { FileSearch } from '../file-search/file-search';
import { Bootstrap } from '@synegen/utility';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'ems-file-drawer',
  imports: [
    Drawer,
    FormsModule,
    FileSearch,
    TranslatePipe
  ],
  templateUrl: './file-drawer.html',
  styleUrl: './file-drawer.scss',
  standalone: true
})
export class FileDrawer {
  fileUploaderService: FileUploaderService = inject(FileUploaderService);
  bootstrap: Bootstrap = inject(Bootstrap);
  init = () => {

  };

  clear = () => {

  };
}

